import React from 'react';
import PropTypes from 'prop-types';
import keyMirror from 'keymirror';

import t from '../../../lib/I18n';
import Checkbox from '../../form/Checkbox';


// Use keyMirror for feature keys
const Features = keyMirror({
    quietCoach: null,
    nearToilets: null,
    powerSocket: null,
    nearLuggageRack: null,
});

// Build array dynamically from Features
const featureCheckboxes = Object.keys(Features).map(key => ({
    name: key,
    key: key,
}));

const FeatureCheckboxes = ({ seatingPreferences, handleCheckboxChange }) => {
    return (
        <div className="seat-container__item">
            <div className="seat-container__item--title">
                {t('booking.seating.features')}
            </div>
            <div className="radio-row">
                {featureCheckboxes.map(({ name, key }) => (
                    <Checkbox
                        key={name}
                        name={name}
                        className="reservation-checkbox"
                        label={t(`booking.seating.features.${key}`)}
                        checked={seatingPreferences.get(name)}
                        onChange={handleCheckboxChange(name)}
                    />
                ))}
            </div>
        </div>
    );
};

FeatureCheckboxes.propTypes = {
    seatingPreferences: PropTypes.object.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
};

export default FeatureCheckboxes;



// WEBPACK FOOTER //
// ./src/components/account/reservations/FeatureCheckboxes.js